export default function randomEducationalMessage() {
    const educationalMessage = document.getElementsByClassName(
        "educational-message"
    );
    const randomNumber = Math.floor(Math.random() * educationalMessage.length);
    educationalMessage[randomNumber].classList.add("d-block", "text-center");
    educationalMessage[randomNumber].classList.remove("d-none");
}